import { theme } from '@factorialco/deprecated-design-system'
import { ThemeAPI } from 'nuvo-react'

export const loader: ThemeAPI['loader'] = {
  root: {
    backgroundColor: theme.colors.grey100,
  },
  content: {
    color: theme.colors.grey800,
  },
  loadAnimationColor: 'rgba(255, 93, 126, 1)',
}
